@if (initialized) {
  <div class="relative z-10" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
    <div class="fixed inset-0 bg-black bg-opacity-30 transition-opacity ease-in-out duration-500"
    [ngClass]="visible ? 'visible opacity-100' : 'invisible opacity-0'"></div>
    <div *transloco="let t; prefix: 'checkout.cartDrawer'"
      class="fixed inset-0 overflow-hidden overlay-container" [ngClass]="visible ? 'visible' : 'invisible'">
      <div class="absolute inset-0 overflow-hidden" (click)="overlayClick($event)" #overlay>
        <div class="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
          <div class="pointer-events-auto w-screen max-w-md transform transition ease-in-out duration-300"
                     [ngClass]="{
                           'translate-x-full': !visible,
                           'translate-x-0': visible
                            }"
            >
            <div class="flex h-full flex-col bg-main shadow-xl">
              <div class="flex-1 height-full flex flex-col overflow-y-hidden py-6 px-2">
                <div class="flex items-center justify-between px-2">
                  <h3 class="text-lg font-medium text-gray-900">{{ t('title') }}</h3>
                  <button class="btn" (click)="close.emit()">
                    <div class="pi pi-times text-gray-400"></div>
                  </button>
                </div>
                @if ( isOrderBlocked$ | async ) {
                  <div class="mt-2 space-y-2 p-2">
                    <div class="border border-amber-200 bg-amber-50 rounded-md text-center p-2 " [innerHTML]="t('cardIsBlocked')"></div>
                    <p-button (click)="continuePurchasing()"
                      styleClass="button-base text-gray-900 mt-2">
                      {{ t('continuePurchasing') }}
                    </p-button>
                  </div>
                }
                @if (!(isEmpty$ | async)) {
                  <div class="mt-8 px-1 overflow-y-auto">
                    <vsf-cart-contents [cart]="cart$ | async"
                      [canAdjustQuantities]="!(isOrderBlocked$ | async)"
                      [isCompany]="(isCompany$ | async)"
                    (setQuantity)="setQuantity($event)"></vsf-cart-contents>
                  </div>
                } @else {
                  <div class="flex items-center justify-center h-48 text-xl text-gray-400">
                    {{ t('cartIsEmpty') }}
                  </div>
                }
              </div>
              @if (cart$ | async; as cart) {
                @if (cart.lines.length > 0) {
                  <div class="border-t border-gray py-6 px-4 sm:px-6">
                    <div class="border border-gray rounded-md bg-white space-y-2 p-2">
                      @if (summary$ | async; as s) {
                        <div class="flex justify-between font-medium text-gray-900">
                          <p>{{ t('subtotal') }}</p>
                          <p>{{ s.originalSubtotalWithTax | formatPrice }}</p>
                        </div>
                        @if (s.discountAmount > 0) {
                          <div class="flex justify-between font-medium text-red">
                            <p>{{ t('discount') }} ({{ s.discountPercent }}%)</p>
                            <p>-{{ s.discountAmount | formatPrice }}</p>
                          </div>
                        }
                        <div class="flex justify-between font-medium text-gray-900">
                          <p>{{ (taxLabel$ | async) }}</p>
                          <p>{{ s.taxAmount | formatPrice }}</p>
                        </div>
                        @if (s.shippingWithTax > 0) {
                          <div class="flex justify-between font-medium text-gray-900">
                            <p>{{ t('shipping') }}</p>
                            <p>{{ s.shippingWithTax | formatPrice }}</p>
                          </div>
                        }
                        <div class="flex justify-between font-bold text-gray-900 pt-2 border-t border-gray-200">
                          <p>{{ t('total') }}</p>
                          <p>{{ s.totalWithTax | formatPrice }}</p>
                        </div>
                      }
                    </div>
                    <div class="">
                      <p-button (click)="close.emit()"
                        [routerLink]="['/cart']"
                        styleClass="button-base text-gray-900 mt-6">
                        {{ t('openCart') }}
                        <i class="pi pi-arrow-up-right-and-arrow-down-left-from-center text-xs"></i>
                      </p-button>
                      <p-button (click)="close.emit()"
                        [routerLink]="['/checkout']"
                        styleClass="button-base text-gray-900 mt-3">
                        {{ t('checkoutButton') }}
                        <i class="pi pi-chevron-right text-xs"></i>
                      </p-button>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
